const NON_INVESTING_ASSET_TYPES = ["current_account"];

export const assetGrossValueZar = (asset, supportedCurrencies) =>
  convertAssetCurrencyToZar(
    asset.gross_value,
    supportedCurrencies[asset.currency]
  );

export const assetMonthlyIncomeValueZar = (asset, supportedCurrencies) => {
  let monthly_income = asset.computedAttributes?.totalMonthlyIncome;
  if (monthly_income === undefined) {
    monthly_income = asset.monthly_income;
  }

  return convertAssetCurrencyToZar(
    monthly_income,
    supportedCurrencies[asset.currency]
  );
};

export const assetMonthlyContributionValueZar = (
  asset,
  supportedCurrencies
) => {
  let monthly_contribution = asset.computedAttributes?.totalMonthlyContribution;
  if (monthly_contribution === undefined) {
    monthly_contribution = asset.monthly_contribution;
  }

  return convertAssetCurrencyToZar(
    monthly_contribution,
    supportedCurrencies[asset.currency]
  );
};

export const convertAssetCurrencyToZar = (value, exchangeRate) => {
  return value * exchangeRate;
};

export const totalCapital = (assets, supportedCurrencies) =>
  assets
    .filter((asset) => !asset.flagged_for_deletion)
    .reduce(
      (accumulator, asset) =>
        assetGrossValueZar(asset, supportedCurrencies) + accumulator,
      0
    );

export const totalContributions = (assets, supportedCurrencies) =>
  assets
    .filter((asset) => !asset.flagged_for_deletion)
    .reduce(
      (accumulator, asset) =>
        assetMonthlyContributionValueZar(asset, supportedCurrencies) +
        accumulator,
      0
    );

export const totalIncomeFromInvestments = (assets, supportedCurrencies) =>
  assets
    .filter((asset) => !asset.flagged_for_deletion)
    .reduce(
      (accumulator, asset) =>
        assetMonthlyIncomeValueZar(asset, supportedCurrencies) + accumulator,
      0
    );

export const nonInvestingAsset = (asset) => {
  return NON_INVESTING_ASSET_TYPES.includes(asset.asset_type);
};
